import * as timeUtil from '@/utils/dateTimeUtil'

const emergencyActionMeta = {
  stop_moving: { variant: 'action-stop', icon: '!' },
  stop_moving_recover: { variant: 'action-recover', icon: '&#10003;' }
}

const alertInfoTypeMeta = {
  1: { labelKey: 'alertInfoObstacleAvoidanceFailed', variant: 'action-stop', icon: '!' },
  2: { labelKey: 'alertInfoBehaviorProhibitionFailed', variant: 'action-stop', icon: '!' }
}

const escapeHtml = value => String(value == null ? '' : value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;')

const createDetailRow = (label, content, valueClass, rowClass) => `
  <div class="emergency-detail-row ${rowClass}">
    <span class="emergency-detail-label">${escapeHtml(label)}</span>
    <span class="emergency-detail-value ${valueClass}">${content || '<span class="emergency-detail-empty">&mdash;</span>'}</span>
  </div>`

const createBadge = (label, meta) => `
  <span class="emergency-action-badge emergency-${meta.variant}" title="${escapeHtml(label)}">
    <span class="emergency-action-icon" aria-hidden="true">${meta.icon}</span>
    <span>${escapeHtml(label)}</span>
  </span>`

const translateValue = (translate, key, fallback = '') => {
  if (!key) return fallback
  const translated = translate(key)
  return translated === undefined || translated === null || translated === key
    ? fallback || key
    : translated
}

const formatDataTime = value => (
  value !== undefined && value !== null && value !== ''
    ? timeUtil.formatTime(value)
    : ''
)

export const buildNotificationContent = (sourceType, message, translate) => {
  const payload = message.data || {}
  const robotName = message.robotName || ''
  const robotCode = message.robotCode || ''
  const rows = [
    createDetailRow(translate('robot'), escapeHtml(robotName), 'emergency-value-robot', 'emergency-row-robot'),
    createDetailRow(translate('dashboard_robotCode'), escapeHtml(robotCode), 'emergency-value-code', 'emergency-row-code')
  ]

  let titleKey = 'emergencyNotificationTitle'

  if (sourceType === 'alert_info') {
    titleKey = 'alertInfoNotificationTitle'
    const typeMeta = alertInfoTypeMeta[payload.type] || {
      variant: 'action-unknown',
      icon: '?'
    }
    const typeLabel = typeMeta.labelKey
      ? translateValue(translate, typeMeta.labelKey, String(payload.type || ''))
      : String(payload.type || '')

    rows.push(
      createDetailRow(
        translate('alertInfoType'),
        typeLabel ? createBadge(typeLabel, typeMeta) : '',
        'emergency-value-alert',
        'emergency-row-alert'
      )
    )
  } else {
    const action = payload.action || ''
    const reason = payload.reason || ''
    const actionMeta = emergencyActionMeta[action] || {
      variant: 'action-unknown',
      icon: '?'
    }
    const actionLabel = translateValue(translate, action, action)
    const reasonLabel = reason
      ? translateValue(translate, `${action}_disconnection`, reason)
      : ''

    rows.push(
      createDetailRow(
        translate('action'),
        action ? createBadge(actionLabel, actionMeta) : '',
        'emergency-value-action',
        'emergency-row-action'
      ),
      createDetailRow(
        translate('reason'),
        reason ? `<span class="emergency-reason-text">${escapeHtml(reasonLabel)}</span>` : '',
        'emergency-value-reason',
        'emergency-row-reason'
      )
    )
  }

  rows.push(
    createDetailRow(
      translate('dashboard_dataTime'),
      escapeHtml(formatDataTime(payload.dataTime)),
      'emergency-value-time',
      'emergency-row-time'
    )
  )

  return {
    title: translate(titleKey),
    description: rows.join(''),
    robotId: message.robotId || ''
  }
}
